import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PatientDomicileForm} from '@/features/patients/components/patient-domicile-form/PatientDomicileForm'
import {PatientPersonalDataForm} from '@/features/patients/components/patient-personal-data-form/PatientPersonalDataForm'
import {PatientResidenceForm} from '@/features/patients/components/patient-residence-form/PatientResidenceForm'
import {PatientExtended} from '@/features/patients/types'

export const PatientPersonalInfoFields = ({patient}: {patient: PatientExtended}) => {
    return (
        <Flexbox direction="column" gap={8} fullWidth>
            <PatientPersonalDataForm />
            <PatientResidenceForm
                defaultCoordinates={
                    patient?.residence
                        ? {
                              latitude: patient.residence.city.latitude,
                              longitude: patient.residence.city.longitude
                          }
                        : undefined
                }
            />
            <PatientDomicileForm
                defaultCoordinates={
                    patient?.domicile
                        ? {
                              latitude: patient.domicile.city.latitude,
                              longitude: patient.domicile.city.longitude
                          }
                        : undefined
                }
            />
        </Flexbox>
    )
}
